import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  id: "skills",
  class: "flex flex-col justify-around"
}
const _hoisted_2 = { class: "py-2 mb-1 v-highlight text-h2" }
const _hoisted_3 = /*#__PURE__*/_createTextVNode("skills")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_skill_ball = _resolveComponent("skill-ball")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("h2", _hoisted_2, [
      _createVNode(_component_router_link, {
        class: "header-anchor",
        to: { hash: '#skills' }
      }, {
        default: _withCtx(() => [
          _hoisted_3
        ]),
        _: 1
      })
    ]),
    _createVNode(_component_skill_ball)
  ]))
}